import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/ChipGroup/components/Container.js';
export const ChipGroup = /*#__PURE__*/_styled(forwardRef(({
  overflow = 'wrap',
  alignment = 'start',
  children,
  ...restProps
}, ref) => {
  return _jsx(Container, {
    ...restProps,
    ref: ref,
    overflow: overflow,
    alignment: alignment,
    children: children
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e19cr2if0"
} : {
  target: "e19cr2if0",
  label: "ChipGroup"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoaXBHcm91cC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJDaGlwR3JvdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQ2hpcEdyb3VwL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmV4cG9ydCBjb25zdCBDaGlwR3JvdXAgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBvdmVyZmxvdyA9ICd3cmFwJywgYWxpZ25tZW50ID0gJ3N0YXJ0JywgY2hpbGRyZW4sIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIG92ZXJmbG93OiBvdmVyZmxvdywgYWxpZ25tZW50OiBhbGlnbm1lbnQsIGNoaWxkcmVuOiBjaGlsZHJlbiB9KSk7XG59KSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGlwR3JvdXAuanMubWFwIl19 */");